import React from 'react';
import BaseCompetency from '../Application/BaseCompetency';
import { RN_COMPETENCY_ITEMS } from './rnConstants';

const RnCompetency = ({ targetUserId, onClose }) => {
    return (
        <BaseCompetency
            role="RN"
            title="RN CLINICAL COMPETENCY ASSESSMENT"
            items={RN_COMPETENCY_ITEMS}
            totalPages={9}
            apiEndpoint="/competencies"
            fetchEndpoint="/competencies"
            defaultValues={{
                userId: targetUserId || 1
            }}
            onClose={onClose}
        />
    );
};

export default RnCompetency;
